<template>

  <div class="popup-dv m-auto">
    <!-- HEADER -->
    <div class="popup-dv-header">
      <button class="btn rent action-btn d-flex" ref="rentIcon" style="width: auto !important">

        <span ref="cartBadge" style="color: white; font-size: 12px"> Thuê</span>
        <span ref="cartBadge" style="color: white; font-size: 12px" v-if="rentCount">({{ rentCount }})</span>
      </button>

      <button class="btn buy action-btn" ref="buyIcon" style="width: auto !important; margin-left: 15px;">
        <span ref="cartBadge" style="color: white; font-size: 12px"> Mua</span>
        <span ref="cartBadge" v-if="buyCount" style="color: white; font-size: 12px">({{ buyCount }})</span>
      </button>

      <span class="m-auto" style="font-size: 18px; font-weight: 700">
        {{ product?.name }}
      </span>
 <a id="urlHome" href="vi/thietbithietyeu" style="margin: 0 10px"><img style="width: 40px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>



    <!-- CONTENT -->
    <div class="tab-content" style="    height: 500px;  overflow: auto;">
      <!-- TAB SẢN PHẨM -->
      <div v-if="activeTab === 'Sản phẩm'">
        <!-- ẢNH -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-7">

              <div class="main-img m-auto">
                <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=' + currentImage" />
              </div>

              <div class="thumb-list mt-5">
                <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
                  @click="currentImage = img">
                  <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=' + img" />
                </div>
              </div>


            </div>
            <!-- col-12 d-block d-md-none -->
            <div class="col-12 d-block d-md-none">
              <div v-if="comboProducts.length" class="combo-box mt-3">
                <div class="combo-title">🎁 Sản phẩm trong combo</div>

                <div class="combo-list">
                  <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                    :class="{ active: selectedComboIds.includes(sp.id) }">
                    <img :src="sp.comboImg" class="combo-img" />

                    <div class="combo-name">
                      {{ sp.comboName }}
                    </div>

                    <div class="combo-price" style="color: blue">
                      {{ currenLang.textSanPhamThue }} :
                      {{ formatPrice(sp.giaThue) }}₫
                    </div>

                    <div class="combo-price">
                      {{ currenLang.textSanPhamBan }} :
                      {{ formatPrice(getComboPrice(sp)) }}₫
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div v-if="product?.links && product?.links?.length">
                <div v-for="(link, i) in product?.links" :key="i">

                  <!-- Nếu link rỗng/null -->
                  <div v-if="!link.linkBaiViet || link.linkBaiViet.trim() === ''">
                    <div class="discount-box mt-4">
                      <div v-for="s in saleList" :key="s" class="discount-row" :class="{ active: autoSale === s }">
                        <div class="discount-left"> {{ currenLang.textSanPham_ChietKhau }} {{ s }}% </div>
                        <div class="discount-right"> {{ saleRules[Number(s)]?.text }} </div>
                      </div>
                    </div>
                  </div>

                  <!-- Nếu là youtube -->
                  <div v-else-if="link.linkBaiViet.includes('youtube.com')">
                    <iframe width="100%" height="200" :src="link.linkBaiViet.replace('watch?v=', 'embed/')"></iframe>
                  </div>

                  <!-- Link thường -->
                  <a v-else :href="link.linkBaiViet" target="_blank" class="link-item">
                    🔗 {{ link.tenBaiViet }}
                  </a>

                </div>
              </div>

              <!-- Nếu không có links luôn -->
              <div v-else>
                <div class="discount-box mt-4">
                      <div v-for="s in saleList" :key="s" class="discount-row" :class="{ active: autoSale === s }">
                        <div class="discount-left"> {{ currenLang.textSanPham_ChietKhau }} {{ s }}% </div>
                        <div class="discount-right"> {{ saleRules[Number(s)]?.text }} </div>
                      </div>
                    </div>
              </div>
              <!-- CHIẾT KHẤU -->


              <!-- SỐ LƯỢNG -->
              <div class="qty-box">
                <div class="qty-label">
                  {{ currenLang.textSanPham_Soluong }}
                </div>
                <div class="qty-control justify-content-between">
                  <button @click="decreaseQty">−</button>
                  <input type="number" v-model.number="quantity" @input="onQtyChange" />
                  <button @click="increaseQty">+</button>
                </div>
                <div v-if="autoSale" class="sale-badge mt-3" style="color: red">
                  🔖 Đã áp dụng - {{ autoSale }}%
                </div>
                <!-- <div v-if="autoSale" class="save">
                🎉 Tiết kiệm
                {{ formatPrice(baseSellPrice * quantity - buyPrice) }}₫ 
              </div> -->
              </div>

              <div class="popup-dv-footer">
                <!-- THUÊ -->
                <button ref="rentBtn" v-if="rentPrice > 0" class="btn rent action-btn" @click="
                  flyToCart('rent');
                addToCart('rent', {
                  product: product,
                  quantity: quantity,
                  unitPrice: Math.round(rentPrice / quantity),
                  total: rentPrice,
                  sale: autoSale,
                });
                ">
                  <div class="btn-title">
                    <span class="action-text">
                      {{ currenLang.textSanPham_ThueNgay }} 📦
                    </span>
                    <span class="action-price"> {{ formatPrice(rentPrice) }}₫ </span>
                  </div>
                </button>

                <!-- MUA -->
                <button ref="buyBtn" v-if="buyPrice > 0" class="btn buy action-btn" @click="
                  flyToCart('buy');
                addToCart('buy', {
                  product: product,
                  quantity: quantity,
                  unitPrice: Math.round(buyPrice / quantity),
                  total: buyPrice,
                  sale: autoSale,
                });
                ">
                  <div class="btn-title">
                    <span class="action-text">
                      {{ currenLang.textSanPham_MuaNgay }} 🛒
                    </span>
                    <span class="action-price"> {{ formatPrice(buyPrice) }}₫ </span>
                  </div>
                </button>
              </div>

              <div v-if="suggestedProducts.length" class="suggested-box mt-4 d-none">
                <div class="suggested-title">
                  🔥 {{ currenLang.textSanPham_GoiY }}
                </div>

                <div class="suggested-list">
                  <div v-for="sp in suggestedProducts" :key="sp.id" class="suggested-item"
                    :class="{ active: selectedSuggestId === sp.id }" @click="toggleSuggest(sp)">
                    <img :src="sp.image.split(';')[0]" class="suggested-img" />

                    <div class="suggested-name text-center">
                      {{ sp.name }}
                    </div>

                    <div class="suggested-price text-center">
                      +
                      {{
                        activeTab === "Sản phẩm"
                          ? formatPrice(sp.giaThue)
                          : formatPrice(sp.price)
                      }}₫
                    </div>

                    <div v-if="selectedSuggestId === sp.id" class="check-icon">
                      ✔
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- d-md-block -->
            <div class="col-12 col-md-12 d-none d-md-block">
              <div v-if="comboProducts.length" class="combo-box mt-4">
                <div class="combo-title">🎁 Sản phẩm trong combo</div>

                <div class="combo-list">
                  <!-- <div v-for="sp in comboProducts" :key="sp.id" class="combo-item" :class="{ active: selectedComboIds.includes(sp.id) }" @click="toggleCombo(sp)"> -->

                  <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                    :class="{ active: selectedComboIds.includes(sp.id) }">
                    <img :src="sp.comboImg" class="combo-img" />

                    <div class="combo-name">
                      {{ sp.comboName }}
                    </div>

                    <div class="combo-price" style="color: blue">
                      {{ currenLang.textSanPhamThue }} :
                      {{ formatPrice(sp.giaThue) }}₫
                    </div>

                    <div class="combo-price">
                      {{ currenLang.textSanPhamBan }} :
                      {{ formatPrice(getComboPrice(sp)) }}₫
                    </div>

                    <div v-if="selectedComboIds.includes(sp.id)" class="check-icon">
                      ✔
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CHIẾT KHẤU + SỐ LƯỢNG -->

        <!-- BADGE SALE -->

        <!-- GIÁ TÓM TẮT -->
        <div class="price-summary d-none">
          <div v-if="autoSale" class="price-row">
            <span>Giá gốc</span>
            <span class="old">
              {{ formatPrice(baseSellPrice * quantity) }}₫
            </span>
          </div>

          <div class="price-row highlight">
            <span>Giá sau ưu đãi</span>
            <span class="final"> {{ formatPrice(buyPrice) }}₫ </span>
          </div>
        </div>
      </div>

      <!-- TAB THÔNG TIN -->
      <div class="qty-box" style="text-align: start;">
        <div class="desc" v-html="formatDesc(product?.description)"></div>
        <div class="desc mt-3" v-html="formatDesc(product?.huongdan)"></div>
        <div style="font-size: 13px; font-weight: 600" class="mt-3">
          {{ currenLang.textSanPham_HinhThucTT }}
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <!-- FOOTER -->

  </div>
   <!-- 🛒 CART FAB -->
        <div class="cart-fab" @click="showCart = true">
            🛒
            <span v-if="cartItems.length" class="cart-badge">
                {{ cartItems.length }}
            </span>


        </div>
         <MainCartSheet v-if="showCart" :items="cartItems" @close="showCart = false" @remove="removeCartItem" />
  <div v-if="toast.show" class="toast">
    {{ toast.message }}
  </div>
  <FooterView></FooterView>
</template>
<script>
import productVi from "@/components/json/jsonProduct.json";
import { languages } from "@/components/languages";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import MainCartSheet from './MainCartSheet.vue';

export default {
  components:{
FooterView,MainCartSheet
  },
  data() {
    return {
      activeTab: "Sản phẩm",
      tabs: ["Sản phẩm", "Thông tin"],
      currentImage: "",
      quantity: 1,
      rentCount: 0,
      buyCount: 0,
      // products: [],
      product: null,
      products: require("@/components/json/jsonProduct.json"),
      comboProducts: [],        // 👈 thêm
      suggestedProducts: [],
      selectedSuggestIds: [],
      selectedComboIds: [],
      selectedSuggestId: null,
         showCart: false,
            cartItems: JSON.parse(localStorage.getItem("cart") || "[]"),
      toast: {
        show: false,
        message: "",
      },
      currenLang: languages.vi,
    };
  },


  mounted() {
    const slug = this.$route.params.slug;
    this.product = productVi.find(p => {
      return this.slugify(p.name) === slug;
    });
                this.cartItems = JSON.parse(localStorage.getItem("cart") || "[]")

  },
  computed: {
    images() {
      return this.product?.image?.split(";") || [];
    },

    comboTotal() {
      return this.comboProducts
        .filter((sp) => this.selectedComboIds.includes(sp.id))
        .reduce((sum, sp) => {
          return (
            sum +
            (this.activeTab === "Sản phẩm"
              ? Number(sp.giaThue)
              : Number(sp.price))
          );
        }, 0);
    },
    suggestTotal() {
      const sp = this.suggestedProducts.find(
        (s) => s.id === this.selectedSuggestId,
      );
      if (!sp) return 0;
      return this.activeTab === "Sản phẩm"
        ? Number(sp.giaThue)
        : Number(sp.price);
    },
    cartCount() {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      return cart.reduce((sum, i) => sum + i.quantity, 0);
    },

    saleList() {
      return this.product?.sale?.split(";").map(Number) || [];
    },

    saleRules() {
      return {
        5: { min: 5, max: 20, text: "5 – 20 sản phẩm" },
        10: { min: 21, max: 50, text: "21 – 50 sản phẩm" },
        15: { min: 51, max: Infinity, text: "Trên 50 sản phẩm" },
      };
    },

    autoSale() {
      let s = null;
      this.saleList.forEach((p) => {
        const r = this.saleRules[p];
        if (r && this.quantity >= r.min && this.quantity <= r.max) s = p;
      });
      return s;
    },

    baseSellPrice() {
      return Number(this.product?.priceTD) || 0;
    },

    baseRentPrice() {
      return Number(this.product?.giaThueTD) || 0;
    },

    buyPrice() {
      const priceTD = this.autoSale
        ? (this.baseSellPrice * (100 - this.autoSale)) / 100
        : this.baseSellPrice;

      return (
        Math.round(priceTD * this.quantity) +
        this.comboTotal +
        this.suggestTotal
      );
    },

    rentPrice() {
      const priceTD = this.autoSale
        ? this.product?.giaThueSaleTD?.[this.autoSale] || this.baseRentPrice
        : this.baseRentPrice;

      return (
        Math.round(priceTD * this.quantity) +
        this.comboTotal +
        this.suggestTotal
      );
    },
  },
  watch: {
    images: {
      immediate: true,
      handler(v) {
        if (v.length) this.currentImage = v[0];
      },
    },
  },
  methods: {
 removeCartItem(index) {
            this.cartItems.splice(index, 1)
            localStorage.setItem("cart", JSON.stringify(this.cartItems))
            window.dispatchEvent(new Event("cartUpdated"))
        },
    slugify(name) {
      return name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "");
    },


    getComboPrice(sp) {
      if (!sp.giaCombo) return 0;

      const arr = sp.giaCombo.split(";");
      console.log("arr ", arr);

      const defaultPrice = Number(arr[0]) || 0;
      const discountPrice = Number(arr[1]) || defaultPrice;

      if (this.autoSale == 5) {
        return discountPrice;
      } else if (this.autoSale == 10) {
        return discountPrice;
      }

      return defaultPrice;
    },
    toggleCombo(sp) {
      const index = this.selectedComboIds.indexOf(sp.id);

      if (index === -1) {
        this.selectedComboIds.push(sp.id);
      } else {
        this.selectedComboIds.splice(index, 1);
      }
    },
    toggleSuggest(sp) {
      // nếu click lại sản phẩm đang chọn → bỏ chọn
      if (this.selectedSuggestId === sp.id) {
        this.selectedSuggestId = null;
      } else {
        this.selectedSuggestId = sp.id;
      }
    },
    formatDesc(text) {
      if (!text) return "";
      return text
        .replace(/\n\n/g, "<br><br>") // xuống dòng đoạn
        .replace(/\n/g, "<br>") // xuống dòng thường
        .replace(/- /g, "• "); // gạch ngang → bullet
    },
    increaseQty() {
      this.quantity++;
    },
    decreaseQty() {
      if (this.quantity > 1) this.quantity--;
    },
    onQtyChange() {
      if (this.quantity < 1) this.quantity = 1;
    },

    formatPrice(v) {
      return Number(v).toLocaleString("vi-VN");
    },
    onBuy() {
      this.$emit("buy", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.buyPrice / this.quantity),
        total: this.buyPrice,
        sale: this.autoSale,
      });
    },

    onRent() {
      this.$emit("rent", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.rentPrice / this.quantity),
        total: this.rentPrice,
        sale: this.autoSale,
      });
    },
    addToCart(type) {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      // if (type === "rent") {
      //   this.rentCount += this.quantity;
      // }

      // if (type === "buy") {
      //   this.buyCount += this.quantity;
      // }
      const unitPrice =
        type === "buy"
          ? Math.round(this.buyPrice / this.quantity)
          : Math.round(this.rentPrice / this.quantity);

      const totalPrice = type === "buy" ? this.buyPrice : this.rentPrice;

      // 🔍 Tìm sản phẩm đã tồn tại (cùng id + cùng type + cùng sale)
      const existingIndex = cart.findIndex(
        (item) =>
          item.id === this.product.id &&
          item.type === type &&
          item.sale === this.autoSale,
      );

      if (existingIndex !== -1) {
        // ✅ Nếu đã có → cộng dồn số lượng
        cart[existingIndex].quantity += this.quantity;
        cart[existingIndex].total += totalPrice;
      } else {
        // ✅ Nếu chưa có → thêm mới
        cart.push({
          id: this.product.id,
          name: this.product.name,
          image: this.product.image?.split(";")[0],
          type,
          quantity: this.quantity,
          sale: this.autoSale,
          unitPrice,
          total: totalPrice,
        });
      }

      localStorage.setItem("cart", JSON.stringify(cart));
      this.$emit("added-to-cart", cart);
      window.dispatchEvent(new Event("cartUpdated"))

      // this.$emit("close")
      // window.location.reload();
    },
    flyToCart(type) {
      const startBtn = type === "rent" ? this.$refs.rentBtn : this.$refs.buyBtn;

      const endIcon =
        type === "rent" ? this.$refs.rentIcon : this.$refs.buyIcon;

      /* kiểm tra tồn tại */

      if (!startBtn || !endIcon) return;

      const start = startBtn.getBoundingClientRect();
      const end = endIcon.getBoundingClientRect();

      const img = document.createElement("img");

      img.src = "https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id="+this.product.image.split(";")[0];

      img.style.position = "fixed";
      img.style.left = start.left + "px";
      img.style.top = start.top + "px";
      img.style.width = "80px";
      img.style.zIndex = "9999";
      img.style.pointerEvents = "none";

      img.style.transition = "all .8s cubic-bezier(.65,-0.35,.35,1.35)";

      img.style.filter = "drop-shadow(0 10px 20px rgba(0,0,0,.25))";

      document.body.appendChild(img);

      setTimeout(() => {
        img.style.left = end.left + "px";
        img.style.top = end.top + "px";
        img.style.width = "30px";
        img.style.opacity = ".6";
      }, 50);

      setTimeout(() => {
        img.remove();

        if (type === "rent") {
          this.rentCount += this.quantity;
        }

        if (type === "buy") {
          this.buyCount += this.quantity;
        }
      }, 800);
    },
  }
};
</script>

<style scoped>
/* ===== RESET NHẸ ===== */
* {
  box-sizing: border-box;
}

/* ===== OVERLAY ===== */
.popup-dv-mask {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ===== CONTAINER ===== */
.popup-dv {
  width: 100%;
  max-width: 1600px;
  height: auto;
  background: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@keyframes popupFade {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== HEADER ===== */
.popup-dv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f1f1f1;
  background: #fff;
}

.popup-dv-header span {
  font-size: 20px;
  font-weight: 700;
}

.popup-dv-header button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* ===== BUTTON ===== */
.btn {
  border-radius: 10px;
  padding: 8px 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: 0.25s;
}

.btn.rent {
  background: linear-gradient(135deg, #f97316, #ef4444);

  color: white;
}

.btn.buy {
  background: linear-gradient(135deg, #06b6d4, #2563eb);
  color: white;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* ===== TAB ===== */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.tab {
  padding: 12px 18px;
  cursor: pointer;
  color: #666;
  font-weight: 500;
  position: relative;
}

.tab.active {
  color: #111;
  font-weight: 700;
}

.tab.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 20%;
  width: 60%;
  height: 3px;
  background: #ef4444;
  border-radius: 10px;
}

/* ===== CONTENT ===== */
.tab-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #f8fafc;
}

/* ===== IMAGE AREA ===== */
.main-img {
  width: 100%;
  height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

.main-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: 0.3s;
}

.main-img img:hover {
  transform: scale(1.05);
}

/* ===== THUMB ===== */
.thumb-list {
  display: flex;
  gap: 10px;
  justify-content: center;
  overflow-x: auto;
  padding-bottom: 5px;
}

/* scroll đẹp hơn */
.thumb-list::-webkit-scrollbar {
  height: 6px;
}

.thumb-list::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
}

/* item */
.thumb {
  min-width: 70px;
  height: 70px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: 0.25s;
  flex-shrink: 0;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* active */
.thumb.active {
  border-color: #ef4444;
  transform: scale(1.05);
}

/* hover đẹp hơn */
.thumb:hover {
  transform: translateY(-3px);
}

/* ===== DISCOUNT (CHIP STYLE) ===== */
.discount-box {
  font-size: 13px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 6px;
  background: #fafafa;
}

.discount-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 6px;
  border-radius: 6px;
  margin-bottom: 3px;
  transition: 0.2s;
}

.discount-row.active {
  background: #ffecec;
  color: #e60023;
  font-weight: 600;
}

.discount-left {
  font-size: 12px;
}

.discount-right {
  font-size: 11px;
  color: #666;
}

/* ===== QUANTITY ===== */
.qty-box {
  margin-top: 18px;
  background: #fff;
  padding: 14px;
  border-radius: 14px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.04);
}

.qty-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qty-control button {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  cursor: pointer;
}

.qty-control input {
  width: 70px;
  text-align: center;
  border: none;
  background: #f8fafc;
  border-radius: 8px;
}

/* ===== COMBO ===== */
.combo-box {
  margin-top: 20px;
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.combo-title {
  font-weight: 700;
  margin-bottom: 10px;
}

.combo-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
}

.combo-item {
  min-width: 150px;
  background: #f9fafb;
  border-radius: 12px;
  padding: 10px;
  text-align: center;
  transition: 0.25s;
}

.combo-item:hover {
  transform: translateY(-5px);
}

.combo-item.active {
  border: 2px solid #ef4444;
}

.combo-img {
  width: 100%;
  height: 90px;
  object-fit: contain;
}

/* ===== LINKS ===== */
.link-box {
  margin-top: 20px;
}

.link-title {
  font-weight: 700;
  margin-bottom: 10px;
}

.link-item {
  display: block;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 10px;
  text-decoration: none;
  color: #111;
  border: 1px solid #eee;
  transition: 0.25s;
}

.link-item:hover {
  background: #f1f5ff;
  border-color: #3b82f6;
  transform: translateX(5px);
}

/* ===== FOOTER ===== */
.popup-dv-footer {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #eee;
}

.popup-dv-footer .btn {
  flex: 1;
  padding: 16px;
  font-size: 16px;
}

.action-price {
  font-size: 18px;
  font-weight: 700;
}

/* ===== TOAST ===== */
.toast {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #111;
  color: #fff;
  padding: 12px 18px;
  border-radius: 12px;
  animation: popupFade 0.3s;
}
</style>
